(function() {
  document.addEventListener('DOMContentLoaded', function() {

    toggleVariant();

    function toggleVariant() {
      let sectionVariants = document.querySelectorAll('.crossSell .quick-add__size');

      sectionVariants.forEach(variant => {
        variant.addEventListener('click', (event) => {
          let currentVariant = event.currentTarget,
              currentProduct = currentVariant.closest('.product'),
              currentButtonsArray = currentProduct.querySelectorAll('.collectionFullpageProduct__contentFooterButton span'),
              productActiveTab = currentProduct.querySelector('.quick-add__size--active');

          if (productActiveTab) {
            productActiveTab.classList.remove('quick-add__size--active');
            currentVariant.classList.add('quick-add__size--active');
          } else {
            currentVariant.classList.add('quick-add__size--active');
          }

          currentButtonsArray.forEach(button => {
            button.dataset.id = currentVariant.dataset.id;
            button.dataset.inventoryQuantity = currentVariant.dataset.inventoryQuantity;
          });
        });
      });
    }
  });
})();
